import React from 'react';
import SignatureCanvas from "react-signature-canvas";
import { Button, Form } from "antd";
import { withNamespaces } from 'react-i18next';

class Signature extends React.Component {
  render() {
    return (
      <div className='signature-canvas-form-item'>
        <Form.Item>
          <h5>{this.props.label}</h5>
          <div className='signature-wrap'>
            <div className='signature-canvas-wrap'>
              {this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: this.props.i18n.t('Required') }] })(
                <SignatureCanvas clearOnResize={false} penColor='black' canvasProps={{width: 310, height: 150, className: 'sig-canvas'}}
                                 ref={(ref) => { this.sigPad = ref }}
                                 onEnd={() => { this.props.form.setFieldsValue({ [this.props.fieldName]: this.sigPad.getCanvas().toDataURL('image/png'), [`${this.props.fieldName}___date_time_delta`]: Date.now() }); }}
                />
              )}
            </div>
            <Button type="danger" htmlType='button' onClick={() => { this.sigPad.clear(); this.props.form.setFieldsValue({ [this.props.fieldName]: null }) }}>{this.props.i18n.t('Clear')}</Button>
          </div>
        </Form.Item>

        <div style={{ display: 'none' }}>
          {this.props.form.getFieldDecorator(`${this.props.fieldName}___date_time_delta`)(
            <input disabled />
          )}
        </div>
      </div>
    );
  }
}

export default withNamespaces()(Signature);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeHope_ii_V2_1/Signature.js